import { render, staticRenderFns } from "./NoNotes.vue?vue&type=template&id=475e16e0&scoped=true&"
import script from "./NoNotes.vue?vue&type=script&lang=js&"
export * from "./NoNotes.vue?vue&type=script&lang=js&"
import style0 from "./NoNotes.vue?vue&type=style&index=0&id=475e16e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e16e0",
  null
  
)

export default component.exports